import { useContext, useEffect, useRef, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import helpers from "src/utils/helpers"
import { Filter, Portal, ServerSideTable } from "src/component"
import { AppText, Button, CustomContainer, FlexRow } from "src/style"
import {feesColumns, feesData} from 'src/utils/table-layout'
import { Add_Edit_Fee } from "src/popup"
import { useNotifier } from "react-pop-notifier"

export const Fees = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {notifier} = useNotifier()
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [view, setView] = useState<string>('')
    
    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        
        const response = !isDownload ? 
            await API.getFees({pageNumber, pageSize, ...filterDataRef.current, returnMax: isDownload})
            : await API.getFeesForDownload()

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'FEES_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    function handleRowAction (row: any, actionType: string) {
        if (actionType === 'edit') {
            setView('edit-fee')
            setSelectedRow(row)
        }
        else {
            decisionBox.show(
                `Are you sure you want to delete this fee?`,
                handleDeleteFee,
                decisionBox.hide,
                `Yes, Delete`,
                'No'
            )
        }
    }

    function handleDeleteFee () {
        notifier.show('Fee Successfully Deleted', null, 'success')
    }

    return (
        <>
            <CustomContainer>
                <FlexRow 
                    justifyContent='space-between' alignItems='flex-start' 
                    bottomMargin='1.5' gap='1.5' wrap='wrap'
                >
                    <AppText textSize='2' color='#101828' fontWeight="500">
                        Fees
                    </AppText>
                    <Button
                        width='13.8' fontWeight="500"
                        height='4' radius='0.8' hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={() => setView('new-fee')}
                    >
                        Add New Fee
                    </Button>
                </FlexRow>
                <ServerSideTable
                    tableData={report}
                    tableColumns={feesColumns(handleRowAction)} 
                    dataFetchMethod={handleFetchReport}
                    totalRows={reportData?.totalRecords}
                    customStyle
                    shouldResetPagination={resetPagination}
                    canFilter={() => setView('filter')}
                    canClear={handleClear}
                    downloadAction={() => handleFetchReport(1, 10, true)}
                />
            </CustomContainer>
            { view === 'filter' &&
                <Portal>
                    <Filter
                        type='fees'
                        onApplyFilter={handleFetchReport}
                        setFilterData={(data: any) => {filterDataRef.current = data}}
                        close={() => setView('')}
                    />
                </Portal>
            }
            { ['new-fee' ,'edit-fee'].includes(view) &&
                <Add_Edit_Fee 
                    getFees={() => {
                        filterDataRef.current = {};
                        handleFetchReport()
                    }}
                    rowData={selectedRow}
                    isEdit={view === 'edit-fee'}
                    close={() => setView('')}
                />
            }
        </>
    )
}